// extracted by mini-css-extract-plugin
module.exports = {"section":"FeaturedCourses_section__NhclK","wrapper":"FeaturedCourses_wrapper__fkOf_"};